import React from 'react'
import starIcon from '../../assets/images/star-icon.png'

const reasons = [
    'Healthcare Software Expertise',
    'AI-Powered Business Automation',
    'Custom Web & Mobile Applications',
    'Enterprise Workflow Solutions',
    'Business Process Consulting',
    'Long-Term Technology Partner',
]

const WhyChooseZaavia = () => {
    return (
        <section className="why-choose-zaavia-area pt-100 pb-100">
            <div className="container">
                <div className="section-title">
                    <span className="sub-title">
                        <img src={starIcon} alt="why choose" />
                        Why Zaavia
                    </span>
                    <h2>Why Businesses Choose Zaavia</h2>
                </div>
                <div className="row justify-content-center">
                    {reasons.map((reason) => (
                        <div className="col-lg-4 col-md-6" key={reason}>
                            <div className="why-choose-item">
                                <h3>
                                    <i className="flaticon-tick"></i>
                                    {reason}
                                </h3>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default WhyChooseZaavia
